import React from "react";
import { FormControl, FormHelperText, TextField } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import { FormikProps, Field } from "formik";

import { IFormFields } from "../LogIn/LogIn";
import {LocationShort, LocationShortWithKey} from "@src/Interfaces/Entity/Location";
import { Values } from "Tools/Values";
import { required } from "Tools/FormValidations";
import { IValuesStore } from "@src/Stores/Values/types";
import { STIconWrapper } from "@src/Components/Common/FormFields/FormSimpleSelect/styles";
import Autocomplete, { AutocompleteInputChangeReason } from "@material-ui/lab/Autocomplete/Autocomplete";
import DirectionsBoat from "@material-ui/icons/DirectionsBoat";
import LocationCity from "@material-ui/icons/LocationCity";
import LocalShipping from "@material-ui/icons/LocalShipping";
import PinDrop from "@material-ui/icons/PinDrop";

import { computed } from "mobx";
import { STItem } from "./styles";

interface IProps {
  values?: IValuesStore;
  className?: string;
  formikProps: FormikProps<IFormFields>;
}

@inject("values")
@observer
class SelectLocation extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);

    let location = null;
    if (!location && this.props.values.location) location = this.props.values.location;
    if (!location && this.locations.length === 1) location = this.locations[0].id;
    if (!location) {
      const lastLocation: string = localStorage.getItem("lastLocation");
      const existingLocation = this.locations.find((_) => _.id === lastLocation);
      if (existingLocation) location = lastLocation;
    }

    if (location) {
      this.props.formikProps.setFieldValue("location", location);
    }
  }

  @computed get locations() {
    return this.props.values.loginLocations.map((item, key) => {

      // @ts-ignore
      item.key = key;

      if (item.type === this.props.values.locationTypes.Office) {
        item.icon = LocationCity;
        return item;
      } else if (item.type === this.props.values.locationTypes.Vessel) {
        item.icon = DirectionsBoat;
        return item;
      } else if (item.type === this.props.values.locationTypes.Truck) {
        item.icon = LocalShipping;
      } else {
        item.icon = PinDrop;
      }

      return item;
    });
  }

  getValue = (formikProps: FormikProps<IFormFields>) => {
    const currentLocation = this.locations.find((location) => location.id === formikProps.values.location);
    if (!currentLocation) {
      return null;
    }
    return currentLocation;
  };

  getIcon = (formikProps: FormikProps<IFormFields>) => {
    const currentLocation = this.locations.find((location) => location.id === formikProps.values.location);
    if (!currentLocation) {
      return null;
    }
    return (
        <STIconWrapper>
          <currentLocation.icon nativecolor="rgba(0, 0, 0, 0.54)" />
        </STIconWrapper>
    );
  };

  handleChange = (event: any, formikProps: FormikProps<IFormFields>) => {
    const selectedLocation = this.locations.find((location) => location.name === event.target.innerText);
    formikProps.setFieldValue("location", selectedLocation ? selectedLocation.id : "");
  };

  handleInputChange = (reason: AutocompleteInputChangeReason, formikProps: FormikProps<IFormFields>) => {
    if (reason === "clear" || reason === "input") {
      formikProps.setFieldValue("location", "");
    }
  };

  render() {
    const formikProps: FormikProps<IFormFields> = this.props.formikProps;
    if (this.locations.length === 1) {
      return null;
    }
    return (
        <Field
            name="location"
            validate={required}
            render={() => (
                <FormControl
                    className={this.props.className}
                    error={formikProps.touched.location && !!formikProps.errors.location}
                >
                  <Autocomplete
                      data-test-id={"location-menu"}
                      options={this.locations}
                      autoComplete={false}
                      value={this.getValue(formikProps)}
                      getOptionLabel={(item) => item.name}
                      onChange={(event: any) => this.handleChange(event, formikProps)}
                      onInputChange={(event: any, value: any, reason: AutocompleteInputChangeReason) =>
                          this.handleInputChange(reason, formikProps)
                      }
                      renderOption={(item: LocationShortWithKey) => {
                        return (
                            <STItem key={item.id} data-test-id={`menu-item-${item.id}`} data-test-key={`menu-item-${item.key}`}>
                              <STIconWrapper>
                                <item.icon nativecolor="rgba(0, 0, 0, 0.54)" />
                              </STIconWrapper>
                              {item.name}
                            </STItem>
                        );
                      }}
                      renderInput={(params) => (
                          <TextField
                              label={Values.getLocalizationValue("location")}
                              {...params}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: this.getIcon(formikProps),
                              }}
                          />
                      )}
                      filterSelectedOptions
                  />

                  {formikProps.touched.location && formikProps.errors.location && (
                      <FormHelperText>{Values.getLocalizationValue("fieldRequired")}</FormHelperText>
                  )}
                </FormControl>
            )}
        />
    );
  }
}

export default SelectLocation;
